import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CompetencyDashboardComponent } from './competency-dashboard/competency-dashboard.component';
import { CompetencyListComponent } from './competency-list/competency-list.component';
import { CompetencyComponent } from './competency/competency.component';

const routes: Routes = [
    {
        path: '',
        component: CompetencyComponent,
        children: [
            {
                path: '',
                component: CompetencyDashboardComponent
            },
        ]
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CompetencyRoutingModule { }